const HomeModel = {
  fetching: false,
  fetched: false,
  error: null,
  mainCity: null,
  featuredCities: [],
  // Badi Plus Collection
  badiPlusCollection: null,
  badiPlusCollectionLoading: false,
  badiPlusCollectionError: null,
  // Room Collections by Place IDs
  roomCollectionsByPlaceIds: null,
  roomCollectionsByPlaceIdsLoading: false,
  roomCollectionsByPlaceIdsError: null,
};

function setInitialState(initialState) {
  const state = initialState;

  if (!state || !state.Home) {
    return { ...HomeModel, error: 'There was an error in HomeModel.' };
  }
  return state;
}

export { HomeModel, setInitialState };
